export default function FileTextCircle() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#18181B" />
      <path
        d="M8.5 7H12.5L15.5 10V16.5C15.5 16.7761 15.2761 17 15 17H8.5C8.22386 17 8 16.7761 8 16.5V7.5C8 7.22386 8.22386 7 8.5 7Z"
        stroke="#A1A1AA"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7V10H15.5"
        stroke="#A1A1AA"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5H14M10 14.5H12.5"
        stroke="#A1A1AA"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
